<template>
  <div class="search">
    <input
      type="text"
      placeholder="Search a plant name..."
      v-model="textSearch"
      @keyup.enter="search"
    />
    <div class="icon">
      <font-awesome-icon icon="search" @click="search" />
    </div>
  </div>
</template>

<script>
import { router } from "@/main";
export default {
  name: "SearchBar",
  props: {},
  components: {},
  data() {
    return {
      textSearch: "",
    };
  },
  methods: {
    async search() {
      router.push({ name: "search", query: { textSearch: this.textSearch } });
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  background: #fff;
  width: 100%;
  border-radius: 5px;
  position: relative;
  box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, 0.12);
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.search input {
  height: 55px;
  width: 100%;
  outline: none;
  border: none;
  border-radius: 5px;
  padding: 0 60px 0 20px;
  font-size: 18px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
}
.search.active input {
  border-radius: 5px 5px 0 0;
}
.search .autocomp-box {
  padding: 0;
  opacity: 0;
  pointer-events: none;
  max-height: 280px;
  overflow-y: auto;
}
.search.active .autocomp-box {
  padding: 10px 8px;
  opacity: 1;
  pointer-events: auto;
}
.search .icon {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 55px;
  width: 55px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  cursor: pointer;
}
</style>
